require('./productInformation.scss');

//@vendors
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');
//@utilities
import { FormattedText, HtmlText } from 'core/i18n';

const ProductInformation = ({ jointHolderAccountType, jointHolderType, noPadding }) => {
    const className = classNames('product', { 'product--no-padding': noPadding });

    return (
        <div className={className}>
            <div className="product-information-box">
                <div className="product__flexContainer">
                    <div className="product__flexContainer-flexColumn-product">
                        <span className="product-information-box__icon icons--icon-acount"></span>
                        <div className="product-information-box__text">
                            <p className="product-information-box__text--title">
                                <FormattedText value="initial-jointHolderInformationProduct" />
                            </p>
                            <p className="product-information-box__text--desc">{HtmlText(jointHolderAccountType)}</p>
                        </div>
                    </div>
                    <div className="product__flexContainer-flexColumn-type">
                        <span className="product-information-box__icon icons--icon-client"></span>
                        <div className="product-information-box__text">
                            <p className="product-information-box__text--title">
                                <FormattedText value="initial-jointHolderInformationInterventionType" />
                            </p>
                            <p className="product-information-box__text--desc">{jointHolderType}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

ProductInformation.propTypes = {
    jointHolderAccountType: PropTypes.string,
    jointHolderType: PropTypes.string,
    noPadding: PropTypes.bool,
};

ProductInformation.defaultProps = {
    jointHolderType: 'Titular',
    jointHolderAccountType: 'Cuenta Corriente',
    jointHolderAccountTypeInfo: false,
    noPadding: false,
};

module.exports.constructor = ProductInformation;
module.exports = ProductInformation;
